"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dynamicStyle = void 0;

var _react = require("@emotion/react");

var _elements = require("../../styles/elements");

var _util = require("../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var base = /*#__PURE__*/(0, _react.css)("&>svg{width:", (0, _util.rem)(24), ";height:", (0, _util.rem)(24), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
var smallStyle = /*#__PURE__*/(0, _react.css)("&>svg{width:", (0, _util.rem)(16), ";height:", (0, _util.rem)(16), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:smallStyle;"));
var iconOnlyStyle = /*#__PURE__*/(0, _react.css)("padding-left:", (0, _util.rem)(7), ";padding-right:", (0, _util.rem)(7), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:iconOnlyStyle;"));
var smallAndIconOnly = /*#__PURE__*/(0, _react.css)("padding-left:", (0, _util.rem)(5), ";padding-right:", (0, _util.rem)(5), ";border-radius:", (0, _util.rem)(6), ";svg{width:", (0, _util.rem)(20), ";height:", (0, _util.rem)(20), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:smallAndIconOnly;"));
var noIcon = /*#__PURE__*/(0, _react.css)("svg{margin-left:-", (0, _util.rem)(4), ";&+span{margin-left:", (0, _util.rem)(6), ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:noIcon;"));
var linkStyle = process.env.NODE_ENV === "production" ? {
  name: "g65o95",
  styles: "text-decoration:none"
} : {
  name: "1jok2sn-linkStyle",
  styles: "text-decoration:none;label:linkStyle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var dynamicStyle = function dynamicStyle(_ref) {
  var theme = _ref.theme,
      size = _ref.size,
      btnType = _ref.btnType,
      iconOnly = _ref.iconOnly,
      as = _ref.as;
  return /*#__PURE__*/(0, _react.css)(_elements.button.styles[btnType](theme), ";", _elements.button.sizes[size](theme), ";", base, ";", size === 'small' && smallStyle, ";", iconOnly && iconOnlyStyle, ";", size === 'small' && iconOnly && smallAndIconOnly, ";", !iconOnly && noIcon, ";", as === 'a' && linkStyle, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:dynamicStyle;"));
};

exports.dynamicStyle = dynamicStyle;
//# sourceMappingURL=Button.styles.js.map